import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChevronUpIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.803 14.899L11.601 10.675L7.39895 14.899L6.10095 13.601L11.601 8.10101L17.101 13.601L15.803 14.899Z'
                fill='currentColor'
            />
        </>
    ),
})

ChevronUpIcon.displayName = 'ChevronUpIcon'
